/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axiosInstance from "../../libs/axios"

export default {

    getInstitutions({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            let queryParams = payload.skip !== undefined ? "?skip=" + payload.skip : ""
            queryParams += payload.take ? "&take=" + payload.take : ""
            axiosInstance.get("institutions" + queryParams).then((response) => {
                commit("SET_INSTITUTIONS", response.data.data);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getInstitutionTranslations({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/institutions/" + payload).then((response) => {
                commit("SET_INSTITUTION_TRANSLATIONS", response.data);
                resolve(response.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    addInstitution({commit}, item) {
        return new Promise((resolve, reject) => {
            axiosInstance.post("/institutions", item)
                .then((res) => {
                    const response = res.data.data
                    commit("ADD_ITEM", Object.assign(item, {id: response.data.id}));
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    updateInstitution({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.put("/institutions/" + payload.id, payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    deleteInstitution({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.delete("/institutions/" + payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

}
